import React, { useState } from 'react';
import '../styles.css';
//internal and external componentscontainers
import { Typography, Paper, Box, Fade, Popper, ClickAwayListener, ThemeProvider, createTheme } from '@mui/material';
import SelectBoxPrimary from '../../../components/SelectBoxPrimary';
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { AvatarAndName } from '../../../components/AvatarAndName';
import { getEvaluationReportStandardDetails, getOffSiteEvaluationByStandard, getOnSiteEvaluation, getStandardsEvidences, getStandardsSelfAssessmentComment } from '../../../api/evaluation';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate, formatDateTime, genUID } from '../../../common/StaticExports';
import { setOffSiteEvaluation, setSaComments, setSaEvidences, setSelectedERStandard, setSelectedOnSiteCriteria } from '../../../redux/reducers/evaluation';
import EvidencesTable from '../../../components/EvidencesTable';
import { useTranslation } from 'react-i18next';
import { baseUrl } from '../../../api/config';
import StatusIndicatorSmall from '../../../components/StatusIndicatorSmall';
import ActionsTableSmall from '../../../components/ActionsTableSmall';

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: 50
                },
            }
        },
    }
})


const EvalReportStandardsDetail = (props: {detail: any, isOpen: boolean, handleClose: any}) => {
    const { detail, isOpen, handleClose } = props;
    const currentClub = useSelector((state:any) => state.clubDetails);
    const selectedERStandard = useSelector((state:any) => state.evaluation.selectedERStandard);
    const evidences = useSelector((state:any) => state.evaluation.saEvidences);
    const selfAssessmentComment = useSelector((state:any) => state.evaluation.saComments);
    const offSiteEvaluation = useSelector((state:any) => state.evaluation.offSiteEvaluation);
    const selectedOnSiteCriteria = useSelector((state:any) => state.evaluation.selectedOnSiteCriteria);
    const [isLoadingEvidences, setIsLoadingEvidences] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [isLoadingERData, setIsLoadingERData] = useState(false);
    const [isLoadingOnSiteData, setIsLoadingOnSiteData] = useState(false);
    const toggleExpanded = () => setExpanded((prev) => !prev);
    const maxLength = 150;
    const shouldTruncate = detail?.description && detail?.description?.length > maxLength;
    const descriptionText = !expanded && shouldTruncate
        ? detail?.description.slice(0, maxLength) + '...'
        : detail?.description;
    const dispatch = useDispatch();
    const [t] = useTranslation();

    React.useEffect(() => {
        if(isOpen) {
            setIsLoadingERData(true);
            getEvaluationReportStandardDetails({standardId: detail.id, clubId: currentClub.id})
            .then((res:any) => {
                setIsLoadingERData(false);
                dispatch(setSelectedERStandard(res));
            });
            setIsLoadingEvidences(true);
            getStandardsEvidences({standardId: detail.id, clubId: currentClub.id})
            .then((res:any) => {
                dispatch(setSaEvidences(res));
                setIsLoadingEvidences(false);
            });
            getStandardsSelfAssessmentComment({standardId: detail.id, clubId: currentClub.id})
            .then((res:any) => {
                dispatch(setSaComments(res));
            });
            getOffSiteEvaluationByStandard({standardId: detail.id, clubId: currentClub.id})
            .then((res:any) => {
                dispatch(setOffSiteEvaluation(res));
            });
            setIsLoadingOnSiteData(true);
            getOnSiteEvaluation({standardId: detail.id, clubId: currentClub.id})
            .then((res:any) => {
                dispatch(setSelectedOnSiteCriteria(res));
                setIsLoadingOnSiteData(false);
            })
        }
    }, [isOpen]);

    const manageERDataChange = (key:any, updatedValue:any) => {
        const tempData = { ...selectedERStandard, [key]: updatedValue };
        dispatch(setSelectedERStandard(tempData));
        setIsEdited(true);
    }

    //handling actions
    const handleChangeActions = (label:any, updatedValue:any, index:any) => {
        var tempActions = selectedERStandard?.actions ? selectedERStandard?.actions : [];
        switch(label) {
            case 'addAction':
                tempActions = [...tempActions, updatedValue];
                break;
            case 'deleteAction': 
                const newActions = tempActions.filter((_:any, i:any) => i !== index);
                tempActions = newActions;
                break;
            default:
                tempActions = tempActions.map((item:any, i:any) => {
                    if (i == index) {
                        return { ...item, [label]: updatedValue };
                    } return item;
                });
                break;
        }
        manageERDataChange('actions', tempActions);
    };

    return(
        <React.Fragment>
            <ThemeProvider theme={theme}>
            <Popper className='popperStyle' open={isOpen} transition>
                    {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={() => {handleClose(isEdited)}}>
            <Fade {...TransitionProps} timeout={350}>
                        <Paper sx={{ p: 2, width: '1200px', height: '90vh', overflowY: 'auto', margin: 'auto', mt: '3vh' }}>
                            <Box className={'standardDetailsHeader'}>
                                <Box className={'detailsWrapper'} sx={{ mt: 0 }}>
                                    <Typography className='fs13 fw700'>{ genUID(detail.uid) + ' ' + detail.name}</Typography>
                                    <Typography className='fs13'>
                                        {descriptionText}
                                        <Typography className='fs13 displayinlineBlock' onClick={toggleExpanded}>
                                            {descriptionText?.length < maxLength ? '' : expanded ? '(Show less)' : '(Show more)'}
                                        </Typography>
                                    </Typography>
                                </Box>
                                <SelectBoxPrimary
                                label={''} 
                                report={'siteReview'} 
                                options={[0, 1, 2, 3]} 
                                isStatus={true} 
                                manageChange={(e:any) => {manageERDataChange('status', e)}}
                                selected={selectedERStandard?.status || 0} />
                            </Box>
                            <Box className={'standardDetailsContainer'}>
                                <Box className={'detailsWrapper'}>
                                    <Typography className='standardsHeading uppercase'>Evidence</Typography>
                                        <Box sx={{ mt: 1 }}>
                                            <EvidencesTable data={evidences} isLoading={isLoadingEvidences} bg={'#FAFAFA'}/>
                                        </Box>
                                </Box>
                                <Box className={'detailsWrapper'}>
                                    <Typography className='standardsHeading uppercase'>{t('SELF_ASSESSMENT')}</Typography>
                                    <Box className={'sdCommentsWrapper cursorNotAllowed'}>
                                        <JoyCssVarsProvider>
                                            <Textarea 
                                            sx={{ borderRadius: '6px', mt: 0, width: '80%', 
                                                // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                '&.Mui-disabled': {
                                                    '--Textarea-disabledColor': 'black',
                                                    color: 'black',
                                                }, }} 
                                            disabled={true}
                                            placeholder='Add comment' minRows={4} maxRows={4}
                                            value={selfAssessmentComment?.comment}/>
                                        </JoyCssVarsProvider>
                                        <Box className={'SDuserDetailsWrapper'}>
                                            {
                                                selfAssessmentComment?.firstName != null &&
                                                selfAssessmentComment?.firstName != ''&&
                                                <>
                                                <AvatarAndName avatarName={selfAssessmentComment?.firstName ? `${selfAssessmentComment.firstName} ${selfAssessmentComment.lastName}` : 'Undefined'}
                                                avatarImage={selfAssessmentComment.avatarPath ? `${baseUrl}/Content${selfAssessmentComment.avatarPath}` : ''} />
                                                <Typography className='fs12' sx={{ ml: '32px', mb: '10px' }}>{formatDateTime(selfAssessmentComment.updatedDate)}</Typography>
                                                </>
                                            }
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className={'detailsWrapper'}>
                                    <Typography className='standardsHeading uppercase'>{t('OFF_SITE') + ' ' + t('EVALUATION')}</Typography>
                                    <Box className={'sdCommentsWrapper cursorNotAllowed'}>
                                        <JoyCssVarsProvider>
                                            <Textarea
                                            sx={{ borderRadius: '6px', mt: 0, width: '80%', 
                                                // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                '&.Mui-disabled': {
                                                    '--Textarea-disabledColor': 'black',
                                                    color: 'black',
                                                }, }} 
                                            disabled={true}
                                            placeholder='Add comment' 
                                            minRows={4} maxRows={4} 
                                            value={offSiteEvaluation?.comment}/>
                                        </JoyCssVarsProvider>
                                        <Box className={'SDuserDetailsWrapper'}>
                                            {
                                                offSiteEvaluation?.firstName != null &&
                                                offSiteEvaluation?.firstName != ''&&
                                                <>
                                                <AvatarAndName avatarName={offSiteEvaluation?.firstName ? `${offSiteEvaluation.firstName} ${offSiteEvaluation.lastName}` : 'Undefined'}
                                                avatarImage={offSiteEvaluation.avatarPath ? `${baseUrl}/Content${offSiteEvaluation.avatarPath}` : ''} />
                                                <Typography className='fs12' sx={{ ml: '32px', mb: '10px' }}>{formatDateTime(offSiteEvaluation.updatedDate)}</Typography>
                                                </>
                                            }
                                            <StatusIndicatorSmall reportType={'siteReview'} status={offSiteEvaluation?.status || 0} />
                                        </Box>
                                    </Box>
                                </Box>
                                {
                                    selectedOnSiteCriteria &&
                                    selectedOnSiteCriteria.length > 0 &&
                                    <Box className={'detailsWrapper'}>
                                        <Typography className='standardsHeading uppercase mb10'>
                                            {t('ON_SITE') + ' ' + t('EVALUATION')}
                                        </Typography>

                                        {!isLoadingOnSiteData && selectedOnSiteCriteria?.length > 0 && selectedOnSiteCriteria?.map((session: any, sessionIndex: number) => (
                                            <React.Fragment key={sessionIndex}>
                                            {session?.sessionAnswers?.length > 0 &&
                                                session.sessionAnswers.map((interview: any, index: number) => (
                                                <React.Fragment key={`${sessionIndex}-${index}`}>
                                                    {index === 0 && (
                                                    <Typography className='fs13 fw700 mb10'>
                                                        {`${session?.sessionName} - ${formatDate(session?.sessionDate)}`}
                                                    </Typography>
                                                    )}
                                                    <Box className={'sdCommentsWrapper cursorNotAllowed'}>
                                                    <JoyCssVarsProvider>
                                                        <Textarea
                                                        sx={{ borderRadius: '6px', mt: 0, width: '80%', 
                                                            // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                            '&.Mui-disabled': {
                                                                '--Textarea-disabledColor': 'black',
                                                                color: 'black',
                                                            }, }} 
                                                        disabled
                                                        placeholder='Add comment'
                                                        minRows={4}
                                                        maxRows={4}
                                                        value={interview?.comment}
                                                        />
                                                    </JoyCssVarsProvider>

                                                    <Box className={'SDuserDetailsWrapper'}>
                                                        {interview?.firstName?.trim() && (
                                                        <>
                                                            <AvatarAndName
                                                            avatarName={`${interview.firstName} ${interview.lastName}`}
                                                            avatarImage={
                                                                interview.avatarPath
                                                                ? `${baseUrl}/Content${interview.avatarPath}`
                                                                : ''
                                                            }
                                                            />
                                                            <Typography
                                                            className='fs12'
                                                            sx={{ ml: '32px', mb: '10px' }}
                                                            >
                                                            {formatDateTime(interview.updatedDate)}
                                                            </Typography>
                                                        </>
                                                        )}
                                                        <StatusIndicatorSmall
                                                        reportType={'siteReview'}
                                                        status={interview?.status || 0}
                                                        />
                                                    </Box>
                                                    </Box>
                                                </React.Fragment>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                }
                                <Box className={'detailsWrapper'}>
                                    <Typography className='standardsHeading uppercase'>{t('EVALUATION')}</Typography>
                                    <Box className={'sdCommentsWrapper'}>
                                        <JoyCssVarsProvider>
                                            <Textarea 
                                            sx={{ borderRadius: '6px', mt: 0, width: '80%' }} 
                                            onChange={(e:any) => {manageERDataChange('comment', e.target.value)}} 
                                            placeholder='Add comment' 
                                            minRows={4} maxRows={4} 
                                            value={selectedERStandard?.comment || ''}/>
                                        </JoyCssVarsProvider>
                                        <Box className={'SDuserDetailsWrapper'}>
                                            {
                                                selectedERStandard?.firstName != null &&
                                                selectedERStandard?.firstName != ''&&
                                                <>
                                                <AvatarAndName avatarName={selectedERStandard?.firstName ? `${selectedERStandard.firstName} ${selectedERStandard.lastName}` : 'Undefined'}
                                                avatarImage={selectedERStandard.avatarPath ? `${baseUrl}/Content${selectedERStandard.avatarPath}` : ''} />
                                                <Typography className='fs12' sx={{ ml: '32px', mb: '10px' }}>{formatDateTime(selectedERStandard.updatedDate)}</Typography>
                                                </>
                                            }
                                            <SelectBoxPrimary
                                            label={''} 
                                            report={'siteReview'} 
                                            options={[0, 1, 2, 3]} 
                                            isStatus={true} 
                                            manageChange={(e:any) => {manageERDataChange('status', e)}}
                                            selected={selectedERStandard?.status || 0} />
                                        </Box>
                                    </Box>
                                </Box>
                                <Box className={'detailsWrapper mb20'}>
                                    <Typography className='standardsHeading uppercase'>Actions</Typography>
                                    {/* <Button 
                                    className={true ? 'smallButton' : 'displayNone'} 
                                    sx={{ float: 'right' }} 
                                    disableElevation 
                                    onClick={() => {manageAddAction()}} 
                                    variant='contained' size='small' 
                                    startIcon={<FontAwesomeIcon className='fs13' icon={faPlus} />} disabled={addAction}>
                                        {'Add Action'}
                                    </Button> */}
                                    <ActionsTableSmall
                                    data={selectedERStandard?.actions}
                                    isLoading={isLoadingERData}
                                    handleChange={handleChangeActions} />
                                </Box>
                            </Box>
                        </Paper>
                    </Fade>
                    </ClickAwayListener>
                    )}
                </Popper>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default EvalReportStandardsDetail;